export const COVERAGE_GROUPS_VALIDATION_RULES = {
  name: {
    isRequiredTrim: {
      value: true,
    },
  },
  withdrawalClientCoverages: {
    atLeastOne: {
      value: {
        field: "checked",
        expectedValue: true,
      },
    },
  },
  emailMessage: {
    isRequiredTrim: {
      value: true,
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/withdrawal-configuration/coverageGroupsValidationRules.js